import { observer } from 'mobx-react-lite';
import { normalizeSearchValue } from '../../shared/normalizeSearchValue';

interface IProps {
	query: string;
	value: string;
}

export const FlightSearchSuggestionItem = observer(
	({ query, value }: IProps) => {
		const normalizedQuery = normalizeSearchValue(query);
		const index = normalizeSearchValue(value).indexOf(normalizedQuery);

		if (index < 0 || normalizedQuery.length === 0) {
			return <div>{value}</div>;
		}

		const before = value.substring(0, index);
		const match = value.substring(index, index + query.length);
		const after = value.substring(index + query.length);

		return (
			<div>
				{before}
				<strong>{match}</strong>
				{after}
			</div>
		);
	},
);
